import QRCode from 'easyqrcodejs'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

function toggleFields(radio: { value: string }) {
    const textbox = document.getElementById("textData")!;
    const fileInput = document.getElementById("fileData")!;

    if (radio.value === 'textbox') {
        textbox.classList.remove("disabled");
        fileInput.classList.add("disabled");
    } else if (radio.value === 'file') {
        textbox.classList.add("disabled");
        fileInput.classList.remove("disabled");
    }
}
toggleFields({value: 'textbox'});

type GenMode = -1 | 0 | 1
const QR_LEVELS = ['M', 'L', 'H', 'Q'] as const

type QRLevel = typeof QR_LEVELS[number]

const generator = async function(event: PointerEvent, genMode: GenMode) {
    event && event.preventDefault();

    const method = (document.querySelector('input[name="method"]:checked')! as HTMLInputElement).value;

    const fragsize = (document.getElementById('fragsize')! as HTMLInputElement).valueAsNumber;
    const textData = (document.getElementById('textData')! as HTMLInputElement).value;
    const fileData = (document.getElementById('fileData')! as HTMLInputElement).files?.item(0) ?? null
    const correctLevel = (document.getElementById("correctLevel")! as HTMLSelectElement).selectedOptions[0].value;

    let textValue: string | null
    if (method === 'textbox') {
        textValue = textData
    } else if (method === 'file') {
        textValue = await new Promise((resolve, reject) => {
            if (!fileData) {
                alert('请选择一个文件')
                resolve(null)
            }

            const reader = new FileReader()
            reader.onerror = reject
            reader.onabort = reject
            reader.addEventListener('load', (e: ProgressEvent<FileReader>) => {
                let result = e.target?.result ?? ''
                if (typeof result !== 'string') {
                    result = new TextDecoder('utf-8').decode(result)
                }
                resolve(result)
            })
        })
    } else {
        alert('请粘贴或上传数据')
        return
    }

    if (textValue !== null) {
        processAndGenerateQRCodes(textValue, fragsize, correctLevel as QRLevel, genMode)
    }
};
document.getElementById('generateZip')!.addEventListener('click', (event => generator(event, 0)));
document.getElementById('generateOne')!.addEventListener('click', (event => generator(event, 1)));
document.getElementById('showIt')!.addEventListener('click', (event => generator(event, -1)));
// genMode == 0: genZip
// genMode == 1: downloadOne
// genMode == -1: displayOne

function processAndGenerateQRCodes(data: string, fragsize: number, correctLevelId: QRLevel, genMode: GenMode) {
    if (genMode && data.length > fragsize) {
        alert(`数据总长度不得大于${fragsize}字节`);
        return;
    } else if (data.length > 99 * fragsize) {
        alert(`数据总长度不得大于${99 * fragsize}字节`);
        return;
    }

    (function (ele) {
        if (!ele) return
        ele.innerHTML = '';
        ele.style.display = 'none';
    })(document.getElementById('qrcodes'));
    
    const stubElement = document.createElement('span');
    const correctLevel = QRCode.CorrectLevel[correctLevelId] ?? QRCode.CorrectLevel.M;

    (async function() {
        function canvasToBlob(canvas: HTMLCanvasElement, mimeType = 'image/png'): Promise<Blob> {
            return new Promise((resolve, reject) => {
                canvas.toBlob((blob) => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        reject(new Error('Failed to create Blob from canvas.'));
                    }
                }, mimeType);
            });
        }

        let qr: QRCode

        if (!genMode) {
            const zip = new JSZip();
            let counter = 1;

            for (let i = 0; i < data.length; i += fragsize) {
                const chunk = data.substr(i, fragsize);

                qr = new QRCode(stubElement, {
                    text: chunk,
                    correctLevel
                });

                const canvas = (stubElement.querySelector('canvas')!) as HTMLCanvasElement;
                zip.file(`${counter.toString().padStart(2, '0')}.png`, await canvasToBlob(canvas));
                stubElement.innerHTML = '';	// remove sib-elements

                counter++;
            }
            downloadZip(zip);
        } else {
            qr = new QRCode(stubElement, {
                text: data,
                correctLevel
            });
            //qr.download('QRImage-' + randomName(7));
            const canvas = stubElement.querySelector('canvas')!;
            if (genMode > 0 /*downloadOne*/)
                saveAs(await canvasToBlob(canvas), 'QRImage-' + randomName(8) + '.png');
            else {
                (function (ele) {
                    if (!ele) return
                    ele.appendChild(canvas);
                    ele.style.display = 'block';
                })(document.getElementById('qrcodes'));
            }
            stubElement.innerHTML = '';
        }
    })();
}

const randomName = function(length: number): string {
    var result = '';
    for (var i = 0; i < length; i++) {
        result += '0123456789abcdef'.charAt(Math.floor(Math.random() * 16));
    }
    return result;
};

async function downloadZip(zip: JSZip): Promise<void> {
    const content = await zip.generateAsync({ type: "blob", compression: 'DEFLATE', compressionOptions: { level: 5 } });
    saveAs(content, 'QRData-' + randomName(7) + '.zip');
}